const defaultColors = {
  primary: "#DA5332",
  secondary: "#1E1C1D",
  accent: "#F78524",
  lightaccent: "#F99964",
  white: "#ffffff",
  border: "#E8ECF4",
  gray: "#8391A1",
  text: "#525252",
  textInputBackground: "#F7F8F9",
  textInputMandatory: "#FF0140",
  darkBlack: "#1E232C",
  black: "#000",
  red: "#EB174B",
  lightWhite: "#F1F1F1",
  vsColor: "#9898A4",
  vsBack: "#ECEBF0",
  shadowWhite: "#F7F8F9",
  imageBackGround: "##D9D9D9",
  seprartor: "#474747",
  sepratorLine: "#DADADA",
  unActive: "#F1F3F6",
  grayTab: "#EDEDED",
  blackText: "#1E232C",
  strikerColor: "#939598",
  feilderBack: "#F4F3F3",
  deleteAccount: "#FF5B5B",
  blackShade: "#200E32",
  green: "#00A725",
  borderShade: "#EAEAEA",
  limeGreen: "#49E07C",
  lightGreen: "#7DEFA4",
  borderShade400: "#747474",
  borderShade500: "#D7D8D9",
  nonStrikerColor: "#C6C6C6",
  drawerBorderColor: "#E7E7E7",
  grayshade600: "#EDEDED",
  grayshade700: "#EFEFEF",
  lightBlue: "#F5F7FC",
  grayshade800: "#F4F4F4",
  numberFirstShade: "#FFB527",
  numberSecondShade: "#918F8F",
  numberThirdShade: "#B0510D",
};

export const colors = defaultColors;
